/** *********************************************
  Action types that are handled by users reducer
********************************************** */
export default {
  FETCH_PROFILE_SUCCESS: 'FETCH_PROFILE_SUCCESS',
  FETCH_PROFILE_ERROR: 'FETCH_PROFILE_ERROR',
}



// WEBPACK FOOTER //
// src/actions/profile/actionTypes.js